import React from 'react';
import propTypes from 'prop-types';

import AddNewComponent from 'app/AddNewComponent/components/AddNewComponent';
import ComponentSearch from 'app/ComponentSearch/container';
import CreateNewMasterComponent from 'app/CreateNewMasterComponent/container';
import styles from './ComponentsTab.css';

/**
 * This component is the collection of component shown in Explorer->Component sections/drawer.
 * @returns {React.Component} the components tab component.
 */
const ComponentsTab = ({
  addNewComponentToPage,
  componentsList,
  canEditAtLeastOneComponent,
  checkStatusAndToggleCreateMasterComponent,
  isPageSelected,
  isReadonlyFolder,
  pageTemplateName,
  pageType,
  showCreateMasterComponentDialog,
  toggleCreateMasterComponent
}) => (
  <div className="d-flex flex-column align-items-center">
    {isPageSelected && (
      <AddNewComponent
        className={`mb-4 ${styles.button}`}
        componentsList={componentsList}
        isReadonly={isReadonlyFolder}
        newComponentSelected={addNewComponentToPage}
        pageTemplateName={pageTemplateName}
        pageType={pageType}
      />
    )}
    <CreateNewMasterComponent
      checkStatusAndToggleCreateMasterComponent={checkStatusAndToggleCreateMasterComponent}
      className={`mb-4 ${styles.button}`}
      isReadonly={!canEditAtLeastOneComponent}
      showCreateMasterComponentDialog={showCreateMasterComponentDialog}
      toggleCreateMasterComponent={toggleCreateMasterComponent}
    />
    <div className="mb-3" />
    <ComponentSearch openForEditing />
  </div>
);

ComponentsTab.propTypes = {
  addNewComponentToPage: propTypes.func.isRequired,
  canEditAtLeastOneComponent: propTypes.bool,
  checkStatusAndToggleCreateMasterComponent: propTypes.func.isRequired,
  componentsList: propTypes.array,
  isPageSelected: propTypes.bool,
  isReadonlyFolder: propTypes.bool,
  pageTemplateName: propTypes.string.isRequired,
  pageType: propTypes.string.isRequired,
  showCreateMasterComponentDialog: propTypes.bool,
  toggleCreateMasterComponent: propTypes.func.isRequired
};

ComponentsTab.defaultProps = {
  canEditAtLeastOneComponent: false,
  componentsList: [],
  isPageSelected: false,
  isReadonlyFolder: true,
  showCreateMasterComponentDialog: false
};

export default ComponentsTab;
